<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Screen from "../../../components/screen";
//import Button from "@/components/c-button";
//import Input from "@/components/c-input";
//import Select from "@/components/c-select";
import Loading from "@/components/c-loading";
import i18n from "../../../i18n";
import PaymentTerm from "../../../components/modals/payment-term.vue";
import { scheduleService } from "../../../services/saleservice/schedule.service";
import { saleService } from "../../../services/saleservice/sale.service";
import { servicehelpers } from "../../../services/servicehelpers";


/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Property Change Payment Term",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading,
    //Button,
    //Input,
    //Select,
    PaymentTerm
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "property",
      breadCrumb: {},
      paymenttermData: {},
      scheduleList: {},
      principle: 0,
      selectedSchedule: 0,
      dataPaymentTerm: 0,
      dataStartDate: '',
      selectChangePaymentTerm: null,

    };
  },
  mounted() {

    this.loadingPaymentTermData();
    
    let hasId = 'id' in this.$route.params;
    this.isAdd = this.fetchingStats = !hasId;
    if(hasId) {
      this.loadingData(this.$route.params.id);     
    } else if('propertyid' in this.$route.query) {
      this.loadingPropertyById(this.$route.query.propertyid);
    }
  },

  methods: {
    loadingData: function(id) {
      this.fetchingStats = false;
      scheduleService.preview(id)
        .then(response => {
          this.fetchingStats = true;
          this.scheduleList = response;

          let pending = this.scheduleList.data.filter(item => item.note == 'Pending');
          let first = pending[0];
          this.principle = first.principal;  
          this.selectedSchedule = first.id;
        
        });
    },

    loadingPropertyById: function(id) {
      this.fetchingStats = false;
      saleService.getOneByProperty(id).then(response => {
        if(response.data != null) {
          scheduleService.preview(response.data.id)
          .then(response => {
            this.fetchingStats = true;
            this.scheduleList = response;

            let pending = this.scheduleList.data.filter(item => item.note == 'Pending');
            let first = pending[0];
            this.principle = first.principal;  
            this.selectedSchedule = first.id;
          
          });
        }
      });

      this.fetchingStats = true;
    },

    formatCurrency(value) {

      let sign = '$';
      let decimal = ''; //'.00';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

    },

    openCustomerForm() {
      this.$refs['payment-term'].show();
    },

    paymenttermChange: function(event) {
      // console.log("TEST", event);
      if(event == 1) {
        this.openCustomerForm();
      } else {

        servicehelpers.getPaymentSchedule(event).then(response => {
          this.paymentSchedule = response;
          this.generateSchedule(this.paymentSchedule.data, 1);
        });
        
      }
      
    },

    loadingPaymentTermData: function() {
      servicehelpers.getaymentTermData().then(response => {
        this.paymenttermData = response;
      });
    },

    generateSchedule: function(payment_term_details, rounding_rule_id) {

      let schedule = {
        amount: this.principle,
        deposit: 0,
        start_date: this.dataStartDate == '' ? this.$moment().clone().format('YYYY-MM-DD') + "" : this.dataStartDate,
        decimal_calc_type_id: rounding_rule_id,
        custome_schedule: payment_term_details.map(function(item) {
                            return item['display'];
                          })
      };

      // console.log(schedule);

      scheduleService.custom(schedule)
         .then(response => {
           this.tryingToSubmit = false;

           if(response.status == 200) {
              this.dataSchedule = response.data;
              console.log(JSON.stringify(this.dataSchedule));
           }
          
        });

    },

    getPaymentTerm(event) {

      this.paymenttermData.data.splice(this.paymenttermData.data.findIndex(function(i){
          return i.is_customized == 1;
      }), 1);

      let data = this.paymenttermData.data;

      data.unshift(event);
      this.paymenttermData.data = data;
      this.dataPaymentTerm = event.id;

      this.generateSchedule(data[0].payment_term_details, data[0].rounding_rule_id);
    },

    submitSave: function() {
      
      this.tryingToSubmit = true;

      scheduleService.change({
        schedule_id: this.selectedSchedule,
        schedules: this.dataSchedule
        
      }).then(response => {
        if(response.status == 200) {
          
          this.$swal.fire({
            title: i18n.t('general.success.title'),
            text: i18n.t('general.success.message'),
            icon: "success",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            confirmButtonText: i18n.t('general.success.yes'),
            cancelButtonText: i18n.t('general.success.no')
          }).then(result => {
            if (!result.value) {
              this.$router.push(this.$route.query.redirectFrom || {
                name: "sale-list"
              });
            } 
          });

        }
      });

    }

  }
};
</script>

<template>
  <Layout>
    <PageHeader :items="['']" :title="$t('property.change-term') + ' ' + $t('property.text')" />
    <Loading :loaded="fetchingStats" />

    <PaymentTerm 
      id="payment-term"
      ref="payment-term"
      :title="'viewTitle'"
      @save="getPaymentTerm"
      v-model="selectChangePaymentTerm"
    /> 

    
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
              
              <div class="row" style="padding-top: 10px; padding-bottom: 10px; border-bottom: 1px solid #F6F6FF;">
                
                <div class="col-md-4 row">
                  <div class="col-md-3">
                    {{$t('sale.schedule.no')}}
                  </div>
                  <div class="col-md-9">
                    {{$t('sale.schedule.date')}}
                  </div>
                </div>
                <div class="col-md-2">
                  {{$t('sale.schedule.paid')}}
                </div>
                <div class="col-md-2">
                  {{$t('sale.schedule.principal')}}
                </div>
                <div class="col-md-1">
                  {{$t('sale.schedule.interest')}}
                </div>
                <div class="col-md-1">
                  {{$t('sale.schedule.balance')}}
                </div>
                <div class="col-md-1">
                  {{$t('general.status')}}
                </div>
                <div class="col-md-1">
                  {{$t('general.action')}}
                </div>
              </div>
              <div class="row" style="height: 15px;"></div>
              <div class="row" style="padding-top: 10px; padding-bottom: 10px; border-bottom: 1px solid #F6F6FF;" 
                  v-for="(item, index) in scheduleList.data" :key="index" >
                  <div class="col-md-4 row">
                    <div class="col-md-3">
                      {{index+1}}
                    </div>
                    <div class="col-md-9">
                      {{`${item.pay_date_show} (${item.day_show})`}}
                    </div>
                  </div>
                  <div class="col-md-2">
                    {{formatCurrency(item.integer_pay)}}
                  </div>
                  <div class="col-md-2">
                    {{formatCurrency(item.principal)}}
                  </div>
                  
                  <div class="col-md-1">
                    {{formatCurrency(item.interest)}}
                  </div>
                  <div class="col-md-1">
                    {{formatCurrency(item.balance)}}
                  </div>
                  <div class="col-md-1">
                    <span v-if="item.schedule_status_id == 3" style="font-size: 17pt; line-height: 40%;">&#x2611;</span>
                  </div>
                  <div class="col-md-1">
                    <div v-if="item.schedule_status_id == 1">
                      <a href="">ផ្តូរការបង់ប្រាក់</a>
                      <a href="">បង់ប្រាក់ដើម</a>
                    </div>
                  </div>
              </div>
              <div class="row" style="height: 15px;"></div>
          </div>
        </div>
      </div>

  </Layout>
</template>